export default "__VITE_ASSET__SwWBaBup__"